import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Defaults } from '../helpers/defaults';
import { SessionStateService } from './session-state.service';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  tokenReady: Subject<any> = new Subject<any>();
  expired: boolean;
  constructor(private http: HttpClient, private sessionState: SessionStateService) {
    this.sessionState.setState("downtime",false);//setting downtime here 
    setInterval(() => {
      this.expired=true;
      this.validateToken();
    }, 1200000);//1200000
  }
  public async resovleToken() {
    console.log("Get Earlier@@@@@",this.sessionState.getState("userDetails"))
    if (!this.sessionState.getState("userDetails")) {
      console.log("GettOken@@@@@",this.sessionState.getState("userDetails"))
      this.http.get(Defaults.URL('/getToken')).subscribe(x => {
        this.sessionState.setToken(x['token']);
        this.tokenReady.next(true);
      })
    }
  }
  public OnTokenReady(): Observable<any> {
    setTimeout(() => this.validateToken(), 10);
    return this.tokenReady.asObservable();
  }
  private validateToken() {
    let t= this.sessionState.getToken()
    if(!this.expired && t){
        this.tokenReady.next(true);
    }else{
      this.resovleToken().then(s => this.tokenReady.next(true), e => {this.tokenReady.next(false);console.log("authentication failed")});
    }
  }
}
